import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";

import ManualReview from "./ManualReview";
import ReactTableRow from "../table/ReactTableRow";
import SubTable from "../table/SubTable";
import Table from "../table/Table";
import { TableViewProps } from "../types/adminTypes";

type SlidesTableViewProps = TableViewProps & {
  asyncSlideDetail?: boolean;
};

const SlidesTableView = ({
  headerGroups,
  rows,
  prepareRow,
  lastViewed,
  asyncSlideDetail,
}: SlidesTableViewProps) => {
  return (
    <Table
      className="slidesTable"
      headerGroups={headerGroups.map((headerGroup, index) => (
        <tr {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column: any) => (
            <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
              key={`column:${column.id}`}
            >
              {column.render("Header")}
              <span>
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <FontAwesomeIcon icon="angle-down" />
                  ) : (
                    <FontAwesomeIcon icon="angle-up" />
                  )
                ) : (
                  ""
                )}
              </span>
            </th>
          ))}
        </tr>
      ))}
      rows={rows.map((row: any) => {
        prepareRow(row);
        return (
          <Fragment
            {...row.getToggleRowExpandedProps}
            key={`case:${row.original.id}`}
          >
            <ReactTableRow
              row={row}
              lastViewed={row.original.id === lastViewed}
            />
            {row.isExpanded && (
              <SubTable>
                <ManualReview
                  slide={row.original}
                  onClose={row.toggleRowExpanded}
                  asyncSlideDetail={asyncSlideDetail}
                />
              </SubTable>
            )}
          </Fragment>
        );
      })}
    />
  );
};

export default SlidesTableView;
